    document.addEventListener( 'DOMContentLoaded', function() {
        let lastScrollY = window.scrollY;
        let scrollDirection = 'down';
        window.addEventListener( 'scroll', function() {
            const currentY = window.scrollY;
            if ( currentY > lastScrollY ) {
                scrollDirection = 'down';
            } else {
                scrollDirection = 'up';
            }
            lastScrollY = currentY;
        });
        const blocks = document.querySelectorAll( '[data-transform], [data-opacity]' );
        const observer = new IntersectionObserver( ( entries, obs ) => {
            entries.forEach( entry => {
                if ( entry.isIntersecting ) {
                    const target = entry.target;
                    if ( target.hasAttribute( 'data-transform' ) ) {
                        const endValue = scrollDirection === 'down' ? '1A' : '1B';
                        target.setAttribute( 'data-transform', endValue );
                    }
                    if ( target.hasAttribute( 'data-opacity' ) ) {
                        target.setAttribute( 'data-opacity', '1' );
                    }
                    obs.unobserve( target );
                }
            });
        }, {
            root: null,
            rootMargin: '0px 0px -35px 0px',
            threshold: 0
        });
        blocks.forEach( block => {
            if ( block.hasAttribute( 'data-transform' ) ) {
                const startValue = scrollDirection === 'down' ? '0A' : '0B';
                block.setAttribute( 'data-transform', startValue );
            }
            if ( block.hasAttribute( 'data-opacity' ) ) {
                block.setAttribute( 'data-opacity', '0' );
            }
            observer.observe( block );
        });
    });

    document.querySelectorAll( '.input' ).forEach( function( wrapper ) {
        wrapper.dataset.input = '';
        var field = wrapper.querySelector( 'input:not([type="hidden"]), textarea' );
        if ( !field ) {
            return;
        }
        function updateState() {
            if ( field.value.trim() !== '' || document.activeElement === field ) {
                wrapper.dataset.input = 'focus';
            } else {
                wrapper.dataset.input = '';
            }
        }
        field.addEventListener( 'focus', function() {
            wrapper.dataset.input = 'focus';
        });
        field.addEventListener( 'blur', function() {
            updateState();
        });
        updateState();
    });
    
    document.querySelectorAll( '.select select' ).forEach( function( select ) {
        var wrapper = select.closest( '.select' );
        if ( !wrapper ) {
            return;
        }
        wrapper.dataset.input = '';
        function updateSelectState() {
            if ( select.value && select.value.trim() !== '' || document.activeElement === select ) {
                wrapper.dataset.input = 'focus';
            } else {
                wrapper.dataset.input = '';
            }
        }
        select.addEventListener( 'focus', function() {
            wrapper.dataset.input = 'focus';
        });
        select.addEventListener( 'blur', function() {
            updateSelectState();
        });
        updateSelectState();
    });
